module.exports = __webpack_public_path__ + "static/img/landing-screen-v2-1.9e58be0.png";